import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/shared/lib/cn";

const Tabs = TabsPrimitive.Root;

const TabsList = ({ className, ...props }: TabsPrimitive.TabsListProps) => (
  <TabsPrimitive.List
    className={cn(
      "inline-flex h-10 items-center gap-2 rounded-xl bg-grid-100 p-1 text-sm text-ink-500",
      className
    )}
    {...props}
  />
);

const TabsTrigger = ({
  className,
  ...props
}: TabsPrimitive.TabsTriggerProps) => (
  <TabsPrimitive.Trigger
    className={cn(
      "inline-flex items-center gap-2 rounded-lg px-3 py-2 font-medium transition-colors data-[state=active]:bg-white data-[state=active]:text-ink-900 data-[state=active]:shadow-sm data-[state=active]:shadow-ink-900/5 data-[state=active]:ring-1 data-[state=active]:ring-grid-200 data-[state=active]:ring-offset-0",
      className
    )}
    {...props}
  />
);

const TabsContent = ({
  className,
  ...props
}: TabsPrimitive.TabsContentProps) => (
  <TabsPrimitive.Content
    className={cn("focus-visible:outline-none", className)}
    {...props}
  />
);

export { Tabs, TabsList, TabsTrigger, TabsContent };
